export enum ArrowDirection {
    Prev = 'prev',
    Next = 'next'
}
